var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }, [_c("w-spacer")], 1),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "7" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
                      _c(
                        "w-list",
                        [
                          _vm._l(_vm.items, function (item) {
                            return _c(
                              "w-list-item",
                              { key: item.ID },
                              [
                                _c("w-list-item-text", [
                                  _c(
                                    "div",
                                    [
                                      _vm._v(" " + _vm._s(item.Label) + " "),
                                      item.IsDefault
                                        ? _c("w-chip", [
                                            _vm._v(_vm._s(_vm.$ct("default"))),
                                          ])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("set-as-default"),
                                            expression: "$ct('set-as-default')",
                                          },
                                        ],
                                        attrs: { disabled: item.IsDefault },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setAsDefault(item)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "cogs" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("rename-settings"),
                                            expression:
                                              "$ct('rename-settings')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.renameItem(item)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "edit" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("edit-settings"),
                                            expression: "$ct('edit-settings')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.editItem(item)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "pen" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("delete-settings"),
                                            expression:
                                              "$ct('delete-settings')",
                                          },
                                        ],
                                        staticClass: "danger",
                                        attrs: { disabled: item.IsDefault },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteItem(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "trash" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "w-list-item",
                            {
                              attrs: { disabled: _vm.addMailSettingsDisabled },
                              on: {
                                click: function ($event) {
                                  return _vm.addMailSettings()
                                },
                              },
                            },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "plus" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(_vm._s(_vm.$ct("add-mail-settings"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "5" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("mail-send-options"))),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c("label", { staticClass: "w-label" }, [
                            _vm._v(
                              _vm._s(_vm.$ct("mail-multiple-to-addresses"))
                            ),
                          ]),
                          _vm._l(_vm.recipientModeOptions, function (option) {
                            return _c(
                              "div",
                              {
                                key: option.key,
                                staticClass: "recipient-mode",
                              },
                              [
                                _c("w-radio", {
                                  attrs: {
                                    checked:
                                      _vm.dossierConfig
                                        .MailSendAllRecipientsAsTo ==
                                      option.value,
                                    label: option.text,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onSendAllRecipientsAsToChanged(
                                        option.value
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "recipient-mode-description" },
                                  [_vm._v(_vm._s(option.description))]
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.renameModalSettings != null } },
        [
          _vm.renameModalSettings
            ? _c("app-mail-settings-rename-modal", {
                attrs: { settings: _vm.renameModalSettings },
                on: {
                  close: function ($event) {
                    _vm.renameModalSettings = null
                  },
                  confirm: function ($event) {
                    return _vm.onRenameModalConfirm($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }